import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { getAllHotelResrtvation } from "./hotelAxios";

// Get All Hotel Reservation
export const GetAllHotelResrtvation = createAsyncThunk(
  "hotel/get-all-hotel-reservations",
  async (thunkAPI) => {
    try {
      return getAllHotelResrtvation();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const initialState = {
  data: [],
  isLoading: false,
  isSuccess: false,
  isError: false,
  destination: "",
  message: "",
  item: false,
  show: false,
};

// Country Slice .............
export const hotelSlice = createSlice({
  name: "hotel",
  initialState,
  reducers: {
    setItem: (state, { payload }) => {
      state.item = payload;
    },
    setDestination: (state, { payload }) => {
      // console.log("payload", payload);
      state.destination = state.data.find((item) => item.id == payload) || null;
    },
  },

  extraReducers: (builder) => {
    builder

      // Get all Status
      .addCase(GetAllHotelResrtvation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(GetAllHotelResrtvation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.data = action.payload.data;
      })
      .addCase(GetAllHotelResrtvation.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.error;
        toast.error("Loading Faild");
      });
  },
});

export const resetStateHotel = createAction("Reset_all");
export default hotelSlice.reducer;
export const { setItem, setDestination } = hotelSlice.actions;
